// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"85":"16aa64eff745c64d43ed","569":"b609d7249f689cdef31f"}[chunkId] + ".js";
};